import React, { forwardRef } from 'react';

const SamplesDownloadFormatIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={13}
      height={15}
      viewBox="0 0 13 15"
      fill="none"
      {...otherProps}
    >
      <path
        d="M7.5 4.375V0.287C8.07831 0.505371 8.60359 0.844194 9.041 1.281L11.218 3.46C11.6554 3.89674 11.9946 4.42175 12.213 5H8.125C7.95924 5 7.80027 4.93415 7.68306 4.81694C7.56585 4.69973 7.5 4.54076 7.5 4.375ZM12.5 6.553V11.875C12.4989 12.7035 12.1694 13.4977 11.5835 14.0835C10.9977 14.6694 10.2035 14.9989 9.375 15H3.125C2.29652 14.9989 1.50228 14.6694 0.91646 14.0835C0.330638 13.4977 0.00105842 12.7035 0 11.875V3.125C0.00105842 2.29652 0.330638 1.50228 0.91646 0.91646C1.50228 0.330638 2.29652 0.00105842 3.125 0H5.947C6.047 0 6.147 0.008 6.247 0.015V4.375C6.247 4.62148 6.2956 4.86554 6.39001 5.09323C6.48443 5.32091 6.62281 5.52774 6.79724 5.70189C6.97166 5.87604 7.17872 6.01409 7.40655 6.10814C7.63438 6.20219 7.87852 6.25039 8.125 6.25H12.485C12.492 6.351 12.5 6.451 12.5 6.553ZM7.5 11.875C7.5 11.7092 7.43415 11.5503 7.31694 11.4331C7.19973 11.3158 7.04076 11.25 6.875 11.25H3.75C3.58424 11.25 3.42527 11.3158 3.30806 11.4331C3.19085 11.5503 3.125 11.7092 3.125 11.875C3.125 12.0408 3.19085 12.1997 3.30806 12.3169C3.42527 12.4342 3.58424 12.5 3.75 12.5H6.875C7.04076 12.5 7.19973 12.4342 7.31694 12.3169C7.43415 12.1997 7.5 12.0408 7.5 11.875ZM9.375 9.375C9.375 9.20924 9.30915 9.05027 9.19194 8.93306C9.07473 8.81585 8.91576 8.75 8.75 8.75H3.75C3.58424 8.75 3.42527 8.81585 3.30806 8.93306C3.19085 9.05027 3.125 9.20924 3.125 9.375C3.125 9.54076 3.19085 9.69973 3.30806 9.81694C3.42527 9.93415 3.58424 10 3.75 10H8.75C8.91576 10 9.07473 9.93415 9.19194 9.81694C9.30915 9.69973 9.375 9.54076 9.375 9.375Z"
        fill={color}
      />
    </svg>
  );
});

SamplesDownloadFormatIcon.defaultProps = {
  style: {
    color: '#195AFF',
  },
};

export default SamplesDownloadFormatIcon;
